module.exports = __webpack_public_path__ + "img/horizontal_3_2_pp2_3.c6ca3f38.png";